/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICittaGiftCardContainerData } from './citta-gift-card-container.data';
import { ICittaGiftCardContainerProps } from './citta-gift-card-container.props.autogenerated';

export interface ICittaGiftCardContainerViewProps extends ICittaGiftCardContainerProps<ICittaGiftCardContainerData> {
    GiftCardWrapper: IModuleProps;
    giftCardContent: React.ReactNode[];
    giftCardForm: React.ReactNode[];
    SlotWrapper: INodeProps;
}

/**
 *
 * CittaGiftCardContainer component
 * @extends {React.PureComponent<ICittaGiftCardContainerProps<ICittaGiftCardContainerData>>}
 */
class CittaGiftCardContainer extends React.PureComponent<ICittaGiftCardContainerProps<ICittaGiftCardContainerData>> {
    private moduleClassName: string = 'giftcardCreateWrap';

    public render(): JSX.Element | null {
        const viewProps: ICittaGiftCardContainerViewProps = {
            ...this.props,
            GiftCardWrapper: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName)
            },
            giftCardContent: this.props.slots.slot1,
            giftCardForm: this.props.slots.slot2,
            SlotWrapper: {
                className: 'giftcardsslot-wrapper',
            },
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default CittaGiftCardContainer;
